import React from 'react'
import WizButton from './WizButton'

interface IProps {
    className?: string
    onClick?: () => void
    text?: string
}

const MoreButton: React.FC<IProps> = ({className, onClick, text}) => {
    return (
        <WizButton
            text={text ?? 'More'}
            type={'white'}
            className={`shadow-normal py-[12px] px-[80px] rounded-full font-bold mt-[20px] ${className}`}
            onClick={onClick}
        />
    )
}

export default MoreButton
